<template>
  <FileUploader
    title="Upload Résumé/CV"
    :uploading="uploading"
    :show-upload-dialog="uploadDialog"
    supported-files="pdf, doc, docx"
    @upload="upload"
    @hideModal="hideModal"
    @selectFile="handleFileSelect"
  >
    <template slot="uploadButton">
      <v-row
        no-gutters
        class="mb-4"
      >
        <v-col>
          <v-btn
            rounded
            color="black"
            dark
            medium
            @click="handleUploadResumeClick"
          >
            <span v-if="cvFileUrl">Update Résumé/CV</span>
            <span v-else>Upload Résumé/CV</span>
          </v-btn>
          <p
            v-if="showCvRequiredError"
            class="error--text subtitle-2 mt-1"
          >
            CV is required!
          </p>
          <br>
          <span
            class="pl-2 pr-2 pt-2 caption grey--text text--darken-1"
            v-if="cvFileName"
          >{{ cvFileName }}</span>
        </v-col>
        <v-col v-if="cvFileUrl">
          <a
            :href="cvFileUrl"
            ref="downloadCVTrigger"
            download
            v-show="false"
          >download</a>
          <v-btn
            rounded
            color="secondary"
            small
            download
            :href="cvFileUrl"
          >
            <span>Download Résumé/CV</span>
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </FileUploader>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IUser } from '@/types/models/user.model'
import FileUploader from '@/components/core/FileUploader.vue'
import { uploadCvDialogEvents } from '@/segmentAnalytics/profile'

@Component({
  components: {
    FileUploader
  },
  computed: {
    ...mapGetters(['cvFileName', 'cvFileUrl'])
  }
})
export default class UploadCV extends Vue {
  @Prop({ default: false }) showCvRequiredError: boolean

  // data
  uploadDialog: boolean = false
  uploading: boolean = false

  // computed
  cvFileName: string
  cvFileUrl: string

  // methods
  handleUploadResumeClick () {
    this.$emit('uploadBtnClick')
    this.uploadDialog = true
  }

  hideModal () {
    this.uploadDialog = false
  }

  async upload (file: File) {
    const fileExt = this.getFileExt(file)
    if (!fileExt) return

    uploadCvDialogEvents.trackSubmit(fileExt)
    this.uploading = true
    await this.$store.dispatch('uploadCV', file)
    this.uploading = false
    this.$emit('cvUploaded')
    this.hideModal()
  }

  handleFileSelect (file: File) {
    const fileExt = this.getFileExt(file)
    if (!fileExt) return
    uploadCvDialogEvents.trackSelectFile(fileExt)
  }

  getFileExt (file: File): string|undefined {
    return file.name.split('.').pop()
  }
}
</script>
